import React, {useRef,useContext} from 'react'
import IdleTimer from 'react-idle-timer'
import firebase from '../authentication/firebaseStart'
import app from '../authentication/firebaseStart'
import firebaseUtil from '../data/FirebaseUtil'
import {useTranslation} from "react-i18next";
import {IDEAL_TIMEOUT} from '../data/application.properties';
import {SSOSettingsContext} from '../authentication/SSOSettings';
import { logoutSSOUser } from '../Services/userService';
import { SSO_CONSTANTS } from '../data/constants'
const SESSION_TIMEOUT = 30*60*1000

/**
 * Logout from Firebase and revoke the accessToken at the end of the session timeout.
 * This method covered all the sso and non-sso sessions.
 * @returns {JSX.Element}
 * @constructor
 */
function IdleTimerContainer() {
    const idleTimerRef = useRef(null)
    let localSSOLogin = JSON.parse(localStorage.getItem("ssoLogin"));
    const { SSOSettings } = useContext(SSOSettingsContext);
    const {t} = useTranslation()
    const onIdle = () => {
        console.log("Last Active Time" + idleTimerRef.current.state.lastActive)
        console.log("User is idle logging out...")

        if (localSSOLogin) {
            logoutSSOUser(SSOSettings).then(() => {
                    console.log("Successfully logoutSSOUser");
                }).catch((err) => {
                    console.log("Error in logoutSSOUser", err);
                    return err;
                })
        } else {
            firebaseUtil.revokeTokenAccess(t)
            return firebase.auth().signOut()
        }
    }

    return (
        <div>
            <IdleTimer ref={idleTimerRef} timeout={SESSION_TIMEOUT} onIdle={onIdle}></IdleTimer>
        </div>
    )
}

export default IdleTimerContainer